@if (impacter && !inArticleView) {
  <div class="entity-view-title">{{impacter.name}}</div>
  <div class="impacter-info">
    <div class="positions-panel" [hidden]="toggled">
      <div class="positions">
        <div class="positions-title">{{'content.current-functions' | translate}}</div>
        <div class="positions-list">
          @if (!getPositions(impacter.positions, true).length) {
            <div class="fst-italic color-basic-600">{{'content.no-current-function' | translate}}</div>
          }
          @for (position of getPositions(impacter.positions, true); track position) {
            <div class="position-info">
              <span class="fw-bold">{{position.role}}</span><span> : </span>
              <span>{{position.territory.name}}</span>
              <span class="position-period">
                ({{'content.since' | translate}}
                {{position.startDate | date:'yyyy'}} •
                {{position.nbPositions}} {{(position.nbPositions > 1 ? 'content.positions' : 'content.position') | translate}})
            </span>
            </div>
          }
        </div>
      </div>
      <div class="positions">
        <div class="positions-title">{{'content.old-functions' | translate}}</div>
        <div class="positions-list">
          @if (!getPositions(impacter.positions, false).length) {
            <div class="fst-italic color-basic-600">{{'content.no-old-function' | translate}}</div>
          }
          @for (position of getPositions(impacter.positions, false); track position) {
            <div class="position-info">
              <span class="fw-bold">{{position.role}}</span><span> : </span>
              <span>{{position.territory.name}}</span>
              <span class="position-period">
                ({{position.startDate | date:'yyyy'}} > {{position.endDate | date:'yyyy'}} •
                {{position.nbPositions}}
                {{(position.nbPositions > 1 ? 'content.positions' : 'content.position') | translate}})</span>
            </div>
          }
        </div>
      </div>
    </div>
    @if (toggled) {
      <ex-button type="primary" variant="ghost" size="small" icon="caret-down-fill" (click)="toggled = false">
        {{'content.show-functions' | translate}}
      </ex-button>
    } @else {
      <ex-button type="primary" variant="ghost" size="small" icon="caret-up-fill" (click)="toggled = true">
        {{'content.hide-functions' | translate}}
      </ex-button>
    }
  </div>
}

<div *ngIf="!showLoader && !totalArticleCount" class="no-result">
  <mat-icon svgIcon="close-circle-fill" size="120"></mat-icon>
  <div class="message">
    {{'content.no-result-article-impacter-message' | translate}}
  </div>
</div>
@if (showLoader) {
  <ex-overlay-loader class="impacter-loading" color="secondary" [text]="'search.loading' | translate"/>
}
<div class="articles-panel" [hidden]="!totalArticleCount">
  <div #panel class="articles-content">
    <app-search-bar id="search-im-articles-filter" [currentPage]="'article'" [hidden]="inArticleView"
                    [inImpacterView]="true"></app-search-bar>
    <div class="articles-list">
      <app-articles-page [impacterId]="impacterId"></app-articles-page>
    </div>
  </div>
  <app-filter [hidden]="inArticleView" currentPage="article" [territoryUid]="territoryUid"
              [inImpacterView]="true" [relativeTo]="panel"></app-filter>
</div>
